<template>
  <div class="form-group">
    <h3>Step {{ currentStep }}. {{ travelerLabel ? travelerLabel + ' home' : 'Home' }} airport</h3>

    <div class="form-row valign">
      <AirportPicker class="airport from" placeholder="Home airport (e.g. LAX)" :is-icon="false" :show-title="true" @update:airport="selectFrom" />
    </div>

    <template v-if="!hideRadios">
      <div class="form-row">
        <div class="form-gap">Do you want to return to a different airport?</div>
        <div class="radiolabel" :class="{ on: rtIsDiff === true }" @click="$emit('update:rtIsDiff', true)">
          <div class="radio" />
          <label>Yes</label>
        </div>
        <div class="radiolabel" :class="{ on: rtIsDiff === false }" @click="$emit('update:rtIsDiff', false)">
          <div class="radio" />
          <label>No</label>
        </div>
      </div>

      <template v-if="rtIsDiff">
        <div class="form-row valign">
          <AirportPicker class="airport to" placeholder="Return airport (e.g. DEN)" :airport="to" :is-icon="false" :show-title="true" @update:airport="$emit('update:to', $event?.iata)" />
        </div>
      </template>

      <template v-if="isDiffDatesShown">
        <div class="form-row">
          <div class="form-gap">Do you want to travel on different dates?</div>
          <div class="radiolabel" :class="{ on: isDateDiff === true }" @click="$emit('update:isDateDiff', true)">
            <div class="radio" />
            <label>Yes</label>
          </div>
          <div class="radiolabel" :class="{ on: isDateDiff === false }" @click="$emit('update:isDateDiff', false)">
            <div class="radio" />
            <label>No</label>
          </div>
        </div>

        <div v-if="isDateDiff" class="form-row">
          <input :value="dateDiff" type="text" maxlength="100" required placeholder="Dates you want to travel" @input="$emit('update:dateDiff', $event.target.value)" />
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import AirportPicker from "./common/PickerAirport.vue";

const emit = defineEmits(["update:from", "update:to", "update:rtIsDiff", "update:isDateDiff", "update:dateDiff"]);

const selectFrom = airport => {
  if (["EWR", "JFK", "LGA"].includes(airport?.iata)) {
    alert("Consider searching from 'NYC - All Airports' in case your program's group flights depart from one of the other NYC airports.");
  }
  emit("update:from", airport?.iata);
};

defineProps({
  currentStep: {
    type: Number,
    required: true,
  },
  travelerLabel: {
    type: String,
    default: "Your",
  },
  hideRadios: {
    type: Boolean,
    default: false,
  },
  from: {
    type: String,
    default: null,
  },
  to: {
    type: String,
    default: null,
  },
  rtIsDiff: {
    type: Boolean,
    default: false,
  },
  isDateDiff: {
    type: Boolean,
    default: false,
  },
  dateDiff: {
    type: String,
    default: null,
  },
  isDiffDatesShown: {
    type: Boolean,
    default: true,
  },
});
</script>
